/**
 * Pantallas del módulo **Autoservicio**.
 *
 * Cada una consume un recurso del contrato y lo pinta con su panel; el layout
 * compartido aporta encabezado, filtros y navegación. Sólo se consulta la
 * pantalla visible (el resto de hooks van deshabilitados).
 */

import { useNavigate, useOutletContext } from 'react-router-dom';

import {
  useDetalleAutoservicio,
  useOutboxAutoservicio,
  usePorTurnoAutoservicio,
  useResumenAutoservicio,
} from '../autoservicio.api';
import type { AutoservicioContexto } from '../autoservicio.types';
import { PanelCola } from '../components/panel-cola';
import { PanelOperaciones } from '../components/panel-operaciones';
import { PanelPorTurno } from '../components/panel-por-turno';
import { PanelResumen } from '../components/panel-resumen';

/** `/autoservicio` — KPIs, gráficos y salud del canal. */
export function AutoservicioResumenPage() {
  const { filtros, puedeConsultar } = useOutletContext<AutoservicioContexto>();
  const consulta = useResumenAutoservicio(filtros, puedeConsultar);
  const navegar = useNavigate();

  return (
    <PanelResumen
      datos={puedeConsultar ? consulta.data : undefined}
      cargando={consulta.isFetching}
      error={puedeConsultar ? consulta.error : null}
      onVerTurnos={() => navegar('/autoservicio/turnos')}
      onVerOperaciones={() => navegar('/autoservicio/operaciones')}
      onVerCola={() => navegar('/autoservicio/cola')}
    />
  );
}

/** `/autoservicio/turnos` — agregados por turno. */
export function AutoservicioTurnosPage() {
  const { filtros, puedeConsultar } = useOutletContext<AutoservicioContexto>();
  const consulta = usePorTurnoAutoservicio(filtros, puedeConsultar);

  return (
    <PanelPorTurno
      datos={puedeConsultar ? consulta.data : undefined}
      cargando={consulta.isFetching}
      error={puedeConsultar ? consulta.error : null}
    />
  );
}

/** `/autoservicio/operaciones` — detalle fila por operación. */
export function AutoservicioOperacionesPage() {
  const { filtros, puedeConsultar } = useOutletContext<AutoservicioContexto>();
  const consulta = useDetalleAutoservicio(filtros, puedeConsultar);

  return (
    <PanelOperaciones
      datos={puedeConsultar ? consulta.data : undefined}
      cargando={consulta.isFetching}
      error={puedeConsultar ? consulta.error : null}
    />
  );
}

/** `/autoservicio/cola` — salud de la cola de documentación. */
export function AutoservicioColaPage() {
  const { filtros, puedeConsultar } = useOutletContext<AutoservicioContexto>();
  const consulta = useOutboxAutoservicio(filtros, puedeConsultar);

  return (
    <PanelCola
      datos={puedeConsultar ? consulta.data : undefined}
      cargando={consulta.isFetching}
      error={puedeConsultar ? consulta.error : null}
    />
  );
}
